import React from 'react';

import {RightArrow} from "../../../icons/arrows/right-arrow";
import {LeftArrow} from "../../../icons/arrows/left-arrow";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import classNames from 'classnames';
import styles from '../style/slider-arrow.module.scss';

export class SliderArrowProps extends BaseProps {
  isFirst: Boolean;
  isRtl: Boolean;
  active: Boolean;
  onClick: Function;
}

export const SliderArrow = ({isFirst, isRtl, active, onClick}: SliderArrowProps) => {
  const backgroundProps = {
    className: classNames(styles.background_container, {[styles.background_container_first]: isFirst},
      {[styles.background_container_last]: !isFirst}),
  }

  const containerProps = {
    className: classNames(styles.container,{[styles.active]: active}),
    onClick: () => onClick()
  }

  const Arrow = isFirst ? (isRtl ? RightArrow : LeftArrow) : (isRtl ? LeftArrow : RightArrow);

  return (
    <>
      <div {...containerProps}>
        <Arrow className={classNames(styles.slider_arrow, {[styles.active]: active})}/>
      </div>
      <div {...backgroundProps}/>
    </>
  )
}
